// extracted by mini-css-extract-plugin
export var cardWrapper = "_60-0";